import React, { useState } from "react";
import "./HTML_MAIN_CSS.css";

const HTML_Editor_Examples = () => {
  // Example codes
  const examples = [
    {
      title: "Basic HTML Structure",
      code: `<!DOCTYPE html>
<html>
  <head>
    <title>My First Page</title>
  </head>
  <body>
    <h1>Hello, World!</h1>
    <p>This is my first HTML page.</p>
  </body>
</html>`,
    },
    {
      title: "HTML Headings",
      code: `<h1>Main Heading</h1>
<h2>Subheading</h2>
<h3>Section Heading</h3>`,
    },
    {
      title: "HTML Paragraphs",
      code: `<p>This is a paragraph of text.</p>
<p>Another paragraph with <strong>bold</strong> and <em>italic</em> text.</p>`,
    },
    {
      title: "HTML Links",
      code: `<a href="https://www.example.com">Visit Example.com</a>
<a href="#section2">Go to Section 2</a>`,
    },
    {
      title: "HTML Images",
      code: `<img src="https://via.placeholder.com/150" alt="Sample Image">
<img src="https://via.placeholder.com/100" alt="Small Image">`,
    },
    {
      title: "HTML Lists",
      code: `<!-- Ordered List -->
<ol>
  <li>First item</li>
  <li>Second item</li>
</ol>

<!-- Unordered List -->
<ul>
  <li>Apples</li>
  <li>Oranges</li>
</ul>`,
    },
    {
      title: "HTML Tables",
      code: `<table border="1">
  <tr>
    <th>Name</th>
    <th>Age</th>
  </tr>
  <tr>
    <td>John</td>
    <td>25</td>
  </tr>
  <tr>
    <td>Jane</td>
    <td>30</td>
  </tr>
</table>`,
    },
    {
      title: "HTML Forms",
      code: `<form>
  <label for="name">Name:</label>
  <input type="text" id="name" name="name"><br><br>
  <label for="email">Email:</label>
  <input type="email" id="email" name="email"><br><br>
  <input type="submit" value="Submit">
</form>`,
    },
  ];

  const [selectedExample, setSelectedExample] = useState(examples[0]);

  return (
    <div className="editor-container">
      <h1>HTML Editor Examples</h1>

      {/* Example selector */}
      <select
        onChange={(e) =>
          setSelectedExample(examples.find((ex) => ex.title === e.target.value))
        }
        value={selectedExample.title}
      >
        {examples.map((ex) => (
          <option key={ex.title} value={ex.title}>
            {ex.title}
          </option>
        ))}
      </select>

      {/* Code Display */}
      <section className="code-section">
        <h2>Code:</h2>
        <pre className="code-block">
          <code>{selectedExample.code}</code>
        </pre>
      </section>

      {/* Live Preview */}
      <section className="preview-section">
        <h2>Live Preview:</h2>
        <iframe
          title="html-preview"
          style={{ width: "100%", height: "300px", border: "1px solid #ccc" }}
          srcDoc={selectedExample.code}
        ></iframe>
      </section>
    </div>
  );
};

export default HTML_Editor_Examples;
